/*
 * @Author: liuxiaoyan
 * @Date: 2021-10-11 16:30:23
 * @LastEditors: renmanyi
 * @LastEditTime: 2024-05-13 13:37:14
 * @Description: 描述一下咯
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
 */
module.exports = {
  getParameterByName(name) {
    name = name.replace(/[\\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(location.href);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
  },
  isWeiXin() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('micromessenger') > 0;
  },

  isAlipay() {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('aliapp') > 0 || ua.indexOf('alipay') > 0;
  },

  isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobi/i.test(navigator.userAgent)
  },
  isXiaoMaiApp: () => {
    var ua = navigator.userAgent.toLowerCase();
    return ua.match(/xiaomai_ios/i) || ua.match(/xiaomai_android/i) || getParameterByName('p')==='iOS';
    // return ua.match(/XM_b\(iOS/i) || ua.match(/xiaomai_android/i); // IOS 字符串变化
  },

  isXiaoMaiIOSApp: () => {
    var ua = navigator.userAgent.toLowerCase();
    return ua.match(/xiaomai_ios/i) || getParameterByName('p')==='iOS';
  },

  isXiaoMaiAndroidApp: () => {
    var ua = navigator.userAgent.toLowerCase();
    return ua.match(/xiaomai_android/i);
  },

  isAndroid() {
    const ua = navigator.userAgent.toLowerCase();
    return /android/i.test(ua);
  },
  isIOS() {
    const ua = navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/i.test(ua) || getParameterByName('p')==='iOS';
  },
  isMeiKe() {
    const ua = navigator.userAgent.toLowerCase();
    return /xmappc/i.test(ua);
  },
};



// WEBPACK FOOTER //
// ./src/core/platform.js